import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=cf66142c&"
import script from "./ContactView.vue?vue&type=script&lang=js&"
export * from "./ContactView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports